export const ru = {
    'on-handle-copy-link': 'Ссылка на трансляцию скопирована'
}
